import React, { useState } from "react";
import { FaMapMarkerAlt, FaEnvelope, FaPhoneAlt } from "react-icons/fa";
import Swal from "sweetalert2"; // For SweetAlert
import emailjs from "emailjs-com"; // For EmailJS
import "../Contact/Contact.css";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    message: "",
  });

  const [errors, setErrors] = useState({
    name: "",
    email: "",
    mobile: "",
    message: "",
  });

  // Real-time form validation function
  const validate = (name, value) => {
    let errorsCopy = { ...errors };

    switch (name) {
      case "name":
        errorsCopy.name = /^[A-Za-z\s]+$/.test(value)
          ? ""
          : "Name should contain only alphabets.";
        break;
      case "email":
        errorsCopy.email = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
          ? ""
          : "Invalid email address.";
        break;
      case "mobile":
        errorsCopy.mobile = /^\d{10}$/.test(value)
          ? ""
          : "Mobile number should be 10 digits.";
        break;
      case "message":
        errorsCopy.message =
          value.length >= 15
            ? ""
            : "Message should be at least 15 characters long.";
        break;
      default:
        break;
    }

    setErrors(errorsCopy);
  };

  // Handle input changes and validate
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    validate(name, value);
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!errors.name && !errors.email && !errors.mobile && !errors.message) {
      emailjs
        .sendForm(
          "your_service_id",
          "your_template_id",
          e.target,
          "your_user_id",
        )
        .then(
          (result) => {
            Swal.fire({
              icon: "success",
              title: "Form Submitted!",
              text: "Your enquiry has been sent successfully.",
            });
            // Clear form after successful submission
            setFormData({ name: "", email: "", mobile: "", message: "" });
          },
          (error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong. Please try again later.",
            });
          },
        );
    } else {
      Swal.fire({
        icon: "warning",
        title: "Validation Error",
        text: "Please fill out the form correctly.",
      });
    }
  };

  const handlePhoneClick = () => {
    window.location.href = "tel:0000000000";
  };

  const handleEmailClick = () => {
    window.location.href = "mailto:xyz@trehaniris.com";
  };

  return (
    <>
      <div className="contact-poster">
        <img src="contact.webp" alt="Contact Poster" />
      </div>

      <div className="contact-section">
        <div className="contact-content">
          {/* Left Side: Contact Details */}
          <div className="left-contact">
            <h2>Trehan Iris</h2>
            <div className="div-cd">
              <div className="contact-detail">
                <FaMapMarkerAlt className="contact-icon" />
                <span className="spa-c">
                  Location: Plot No. C2, Sector - ECOTECH - XII, Greater Noida W
                  Rd, Surajpur, Greater Noida, Uttar Pradesh 201310
                </span>
              </div>
              <div className="contact-detail" onClick={handleEmailClick}>
                <FaEnvelope className="contact-icon" />
                <span className="spa-c">Email: xyz@trehaniris.com</span>
              </div>
              <div className="contact-detail" onClick={handlePhoneClick}>
                <FaPhoneAlt className="contact-icon" />
                <span className="spa-c">Toll-Free: 0000000000</span>
              </div>
            </div>
          </div>

          {/* Right Side: Inquiry Form */}
          <div className="right-contact">
            <h2>Send Enquiry</h2>
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <span className="input-label">Name</span>
                <input
                  type="text"
                  name="name"
                  placeholder="Enter your name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
                {errors.name && <span className="errorr">{errors.name}</span>}
              </div>
              <div className="form-group">
                <span className="input-label">Email</span>
                <input
                  type="email"
                  name="email"
                  placeholder="Enter your email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
                {errors.email && <span className="errorr">{errors.email}</span>}
              </div>
              <div className="form-group">
                <span className="input-label">Mobile</span>
                <input
                  type="tel"
                  name="mobile"
                  placeholder="Enter your mobile number"
                  value={formData.mobile}
                  onChange={handleChange}
                  required
                />
                {errors.mobile && (
                  <span className="errorr">{errors.mobile}</span>
                )}
              </div>
              <div className="form-group">
                <span className="input-label">Message</span>
                <textarea
                  name="message"
                  placeholder="Enter your message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                />
                {errors.message && (
                  <span className="errorr">{errors.message}</span>
                )}
              </div>
              <button type="submit">Send</button>
            </form>
          </div>
        </div>
      </div>

      <div className="map-section">
        <div className="map-container">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d224187.98556929943!2d77.16341248671874!3d28.60165850000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cef3e39202f9b%3A0xf64fbe2f14ad21db!2sIris%20Broadway%20Greno%20West!5e0!3m2!1sen!2sin!4v1731503711463!5m2!1sen!2sin"
            width="100%"
            height="300"
            allowFullScreen=""
            loading="lazy"
            title="Location Map"
            style={{ border: "0", borderRadius: "8px" }}
          ></iframe>
        </div>
      </div>

      <section className="contact-section-c">
        <h2>FOR LEASE & SALES ENQUIRIES</h2>
        <p>We want to hear about it</p>
        <div className="contact-cards-c">
          <div className="contact-card-c" onClick={handlePhoneClick}>
            <FaPhoneAlt className="contact-icon-c" />
            <div>
              <p>CALL US NOW</p>
              <h3>0000000000</h3>
            </div>
          </div>
          <div className="contact-card-c" onClick={handleEmailClick}>
            <FaEnvelope className="contact-icon-c" />
            <div>
              <p>GET IN TOUCH</p>
              <h3>xyz@trehaniris.com</h3>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
